/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChessRook = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10.847 5h2.306l.5-3H19v10h-3.4c.67 1.898 1.782 3.3 2.707 4.016A3 3 0 0 1 21 19v3H3v-3a3 3 0 0 1 2.818-2.994c.897-.716 1.963-2.112 2.606-4.006H5V2h5.347zM6 18a1 1 0 0 0-1 1v1h14v-1a1 1 0 0 0-1-1zm4.516-6c-.445 1.578-1.155 2.939-1.954 4h6.955a12.092 12.092 0 0 1-2.016-4zM7 10h10V4h-1.653l-.5 3H9.153l-.5-3H7z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChessRook as ChessRook };
